var map = {
	"./About.vue": [
		"f820",
		"commons",
		"About-vue"
	],
	"./CommentDetail.vue": [
		"c0f9",
		"vendors",
		"commons",
		"CommentDetail-vue"
	],
	"./CommentList.vue": [
		"5013a",
		"vendors",
		"commons",
		"CommentList-vue"
	],
	"./CommentaAppList.vue": [
		"11a4",
		"vendors",
		"commons",
		"CommentaAppList-vue"
	],
	"./GameDetail.vue": [
		"381f",
		"vendors",
		"commons",
		"GameDetail-vue"
	],
	"./GameList.vue": [
		"47b9",
		"vendors",
		"commons",
		"GameList-vue"
	],
	"./HotTagList.vue": [
		"617c",
		"vendors",
		"commons",
		"HotTagList-vue"
	],
	"./Index.vue": [
		"d504",
		"vendors",
		"commons",
		"Index-vue"
	],
	"./LiveAppInstall.vue": [
		"752a",
		"vendors",
		"commons",
		"LiveAppInstall-vue"
	],
	"./NewsDetail.vue": [
		"9c36",
		"vendors",
		"commons",
		"NewsDetail-vue"
	],
	"./NewsList.vue": [
		"c005",
		"vendors",
		"commons",
		"NewsList-vue"
	],
	"./SearchDetail.vue": [
		"e5d8",
		"vendors",
		"commons",
		"SearchDetail-vue"
	],
	"./WealDetail.vue": [
		"d328",
		"vendors",
		"commons",
		"WealDetail-vue"
	],
	"./WealList.vue": [
		"b37c",
		"vendors",
		"commons",
		"WealList-vue"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "1a5d";
module.exports = webpackAsyncContext;